// extracted by mini-css-extract-plugin
export var closeButton = "_7-5";
export var container = "_7-0";
export var contentContainer = "_7-1";
export var desktop = "_7-2";
export var fullModalImage = "_7-6";
export var mobile = "_7-3";
export var withImage = "_7-4";